// API / WebSocket / Banner Base URL 헬퍼
// .env (운영 기본값) / .env.test (테스트) 에서 주입. 누락 시 운영 fallback → 기존 동작 유지(회귀 0)
export const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.infocarbiz.com/web'
export const wsBaseUrl = process.env.VUE_APP_WS_BASE_URL || 'wss://api.infocarbiz.com/web'
export const bannerBaseUrl = process.env.VUE_APP_BANNER_BASE_URL || 'https://banner.infocarbiz.com'
